export interface ShortcutGroup {
  name: string
  shortcuts: Shortcut[]
}

export interface Shortcut {
  keys: string
  description: string
}

export const SHORTCUT_MAP: ShortcutGroup[] = [
  {
    name: 'Navigation',
    shortcuts: [
      { keys: '⌘K', description: 'Open AI Console' },
      { keys: '⌘?', description: 'Show keyboard shortcuts' },
      { keys: '⌘1–7', description: 'Jump to section (Dashboard, Inventory, Listings, etc.)' },
    ],
  },
  {
    name: 'Inventory',
    shortcuts: [
      { keys: '⌘N', description: 'Add new item' },
      { keys: '⌘F', description: 'Search inventory' },
      { keys: '⌘E', description: 'Edit selected item' },
    ],
  },
  {
    name: 'Listings',
    shortcuts: [
      { keys: '⌘L', description: 'Create listing' },
      { keys: '⌘⇧P', description: 'Publish draft listing' },
    ],
  },
  {
    name: 'AI Console',
    shortcuts: [
      { keys: '/draft', description: 'Generate a listing draft' },
      { keys: '/value', description: 'Search comparable sales' },
      { keys: 'Enter (NLQ)', description: 'Ask a natural language question' },
    ],
  },
  {
    name: 'Global',
    shortcuts: [
      { keys: 'Esc', description: 'Close dialog or cancel action' },
      { keys: '⌘S', description: 'Save changes' },
    ],
  },
]
